(function () {
    'use strict';

    angular
        .module('highSchoolVisit')
        .controller('HighSchoolVisitStudentsRegistrationsDataController', HighSchoolVisitStudentsRegistrationsDataController);

    HighSchoolVisitStudentsRegistrationsDataController.$inject = ['HighSchoolVisitService', 'VirtualFairService', 'CitiesByExpoService','$timeout', 'physicalFairs', 'virtualFairs'];

    function HighSchoolVisitStudentsRegistrationsDataController(HighSchoolVisitService, VirtualFairService, CitiesByExpoService,$timeout, physicalFairs, virtualFairs) {
        var vm = this;

        vm.flag                  = false;
        vm.expos                 = [];
        vm.expoSelected          = [];
        vm.expoLocations         = [];
        vm.expoLocationSelected  = [];
        vm.users                 = [];
        vm.getByFilter           = getByFilter;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.cities                = [];
        vm.citySelected          = [];
        vm.schools               = [];
        vm.schoolSelected        = [];
        vm.selectSchoolsByCity   = selectSchoolsByCity;
        vm.students              = [];
        vm.getStudentsCsv        = getStudentsCsv;
        vm.selectEventType       = selectEventType;
        vm.eventTypes            = [{id: 'physical_fair', name: 'Physical Fair'}, {id: 'virtual_fair', name: 'Virtual Fair'}];
        vm.eventTypeSelected     = 'physical_fair';
        vm.physicalFairs         = physicalFairs;
        vm.virtualFairs          = virtualFairs;
        vm.statusOptions         = [{id: -1, name: 'All'}, {id: 1, name: 'Yes'}, {id: 0, name: 'No'}];
        vm.statusSelected        = -1;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        activate();

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.physicalFairs = physicalFairs;
            vm.virtualFairs = virtualFairs;
            vm.selectEventType();
        }

        function selectEventType () {
            if(vm.eventTypeSelected === 'physical_fair') {
                vm.expos = vm.physicalFairs;
            } else {
                vm.expos = vm.virtualFairs;
            }
            vm.expoSelected = [];
        }

        function selectCitiesByExpo () {

            if(vm.eventTypeSelected === 'physical_fair') {
                vm.cities = [];
                vm.citySelected = [];
                vm.schools = [];
                vm.schoolSelected = [];
                CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                    vm.citySelected = [];
                    vm.cities       = response.data;
                }).catch(function(err) {

                });
            } else {
                vm.selectSchoolsByCity();
            }
        }

        function selectSchoolsByCity () {
            vm.schools = [];
            vm.schoolSelected = [];
            vm.query = {};
            vm.query['expo_id'] = vm.expoSelected.id;
            if(vm.eventTypeSelected === 'physical_fair') {
                vm.query['location_id'] = vm.citySelected.expos_locations_id;
                HighSchoolVisitService.getSchoolsByCity(vm.query).then(function(response){
                    vm.schoolSelected   = [];
                    vm.schools          = response.data;
                    vm.schools.unshift({id:-1, name : 'All'});
                    vm.schoolSelected = {id:-1, name : 'All'};
                }).catch(function(err) {
                    //
                });
            } else {
                vm.query['paginate'] = 0;
                VirtualFairService.getSchoolVisits(vm.query).then(function(response){
                    vm.schoolSelected   = [];
                    vm.schools          = response.data;
                    vm.schools.unshift({id:-1, name : 'All'});
                    vm.schoolSelected = {id:-1, name : 'All'};
                }).catch(function(err) {
                    // 
                });
            }
        }

        function getByFilter(newQuery) {
            vm.query = {};
            vm.flag                     = false;
            vm.query['expo_id']         = vm.expoSelected.id;
            vm.query['location_id']     = vm.citySelected.expos_locations_id;
            vm.query['school_id']       = vm.schoolSelected.id;
            vm.query['page']            = vm.page;
            vm.query['event_type']      = vm.eventTypeSelected;
            vm.query['attended']        = vm.statusSelected;
            if(newQuery){
                vm.query['page']        = 1;
            }
            HighSchoolVisitService.getStudents(vm.query).then(function(response) {
                vm.flag = true;
                vm.noResultMessage = '';
                vm.students = response.data.response;
                if(vm.students.length === 0){
                    vm.flag = false;
                    vm.noResultMessage = 'Sorry, no results were found!';
                }
                vm.totalItems = response.data.query.total;
                vm.itemsPerPage = response.data.query.per_page;
                vm.setPage(response.data.query.current_page);
            }).catch(function(err) {
            });
        }

        function getStudentsCsv () {
            vm.query = {};
            vm.query['expo_id']         = vm.expoSelected.id;
            vm.query['location_id']     = vm.citySelected.expos_locations_id;
            vm.query['school_id']       = vm.schoolSelected.id;
            vm.query['event_type']      = vm.eventTypeSelected;
            vm.query['attended']        = vm.statusSelected;
            HighSchoolVisitService.getStudentsCsv(vm.query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                if(vm.eventTypeSelected === 'virtual_fair') {
                    anchor.download = 'school_visit_virtual_fair_' + vm.expoSelected.id + '.csv';
                } else {
                    anchor.download = 'school_visit_' + vm.expoSelected.id + '_' + vm.citySelected.expos_locations_id + '.csv';
                }
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }
    }

})();